<script>
import api from '@/helpers/api'

import { isEmpty } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'address-select',
  props: {
    value: { type: String },
    customerId: { type: String },
    allowCreate: { type: Boolean, default: true }
  },
  components: {
    Multiselect
  },
  data: vm => ({
    addresses: [],
    selected: {},
    newAddressDialogVisible: false
  }),
  methods: {
    async loadData () {
      if (!this.customerId) return
      let { items } = await api.addresses.fetchPage({
        page: 1,
        pageSize: -1,
        filters: [
          {
            is_shipping_address: { _eq: true },
            is_archived: { _eq: false },
            account_id: { _eq: this.customerId }
          }
        ]
      })

      this.addresses = [
        ...items.map(a => {
          return {
            ...a,
            ...a.address
          }
        })
      ]

      this.init()
    },
    init () {
      if (this.addresses.length <= 0) {
        this.selected = null
        return
      }
      if (!isEmpty(this.value)) {
        this.selected = this.addresses.find(c => c.id === this.value)
      } else {
        this.selected = this.addresses.find(c => c.is_default)

        if (isEmpty(this.selected)) this.selected = this.addresses[0]
      }

      this.$emit('input', this.selected ? this.selected.id : undefined)
    },
    onSelected (address) {
      this.$emit('input', address ? address.id : undefined)
    },
    async onNewAddressCreatedHandler (address) {
      if (address.is_default) {
        await api.addresses.updateAll({
          is_default: false,
          where: {
            is_default: { _eq: true }
          }
        })
      }
      var newAddress = await api.addresses.create({
        ...address,
        account_id: this.customerId,
        is_shipping_address: true
      })
      this.$emit('input', newAddress.id)
      this.addresses = [newAddress, ...this.addresses]
      this.selected = newAddress
    }
  },

  mounted () {
    this.loadData()
  },

  watch: {
    value: {
      handler: 'init',
      immediate: true
    },

    customerId: {
      async handler (v) {
        if (v) {
          await this.loadData()
        } else {
          this.addresses = []
          this.selected = null
        }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <div class="d-flex">
    <div class="d-flex flex-column w-100">
      <multiselect
        v-bind="$attrs"
        :options="addresses"
        :custom-label="
          ({ id, company_name, street, number, city, country_code }) =>
            `${company_name}`
        "
        track-by="id"
        v-model="selected"
        :placeholder="$attrs.placeholder || 'Select an Address'"
        :show-labels="false"
        :allow-empty="false"
        v-on:select="onSelected"
        v-on:change="onSelected"
        v-on:close="$emit('blur')"
      >
      </multiselect>
      <template v-if="selected">
        <small class="p-1"
          >{{ selected.street }} {{ selected.number }},{{ selected.city }} ({{
            selected.country_code
          }})</small
        >
      </template>
    </div>
    <template v-if="allowCreate">
      <b-btn
        variant="text"
        v-on:click="newAddressDialogVisible = true"
        class="ml-1 d-flex align-items-center"
        style="height: 38px"
        :disabled="$attrs.disabled || false"
        ><i class="bx bx-plus-circle font-size-20"></i
      ></b-btn>
      <app-address-form-dialog
        :visible.sync="newAddressDialogVisible"
        :customer-id="customerId"
        v-on:created="onNewAddressCreatedHandler"
      />
    </template>
  </div>
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}

.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  display: none;
}
</style>
